module.exports = __webpack_public_path__ + "static/scale-model-of-deep-creek-park-in-hayward-california-d8b2f9509ad500e4e63bd6c4350f0b1d.png";